import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

import LinearProgress from '@material-ui/core/LinearProgress';

import { Grid } from '@material-ui/core';


const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        '& > * + *': {
            marginTop: theme.spacing(2)
        }
    }
}));

const TopLoader = () => {
    const classes = useStyles();

    return (
        <div>
            <div className={classes.root}>
                <LinearProgress color="primary" />
            </div>
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '99vh', maxHeight: "100%" }}>

                <Grid item style={{ display: "flex", gap: 2 }} >

                    <p> Please wait while we are loading </p>
                    {/* <MetroSpinner size={20} color="red" /> */}
                </Grid>

            </div>
        </div>
    );
};

export default TopLoader;
